module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"postDateFormat":"Gepostet am {day}. {month} {year} um {hour}:{minute} Uhr"},"en":{"postDateFormat":"Posted on {month} {day}, {year} at {hour}.{minute}"}}')
  delete Component.options._Ctor
}
